import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { CalculatorLineItem } from '@/modules/tax/models/calculators/CalculatorLineItem';

export class Calculator extends BaseModel {
  calculations?: Record<string, unknown>;
  inputs?: Record<string, unknown>;
  type?: string;
  jurisdictionId?: number;
  lineItems: Relationship<CalculatorLineItem[]> | null;

  constructor(model: Partial<Calculator> = {}) {
    super();
    this.calculations = model.calculations;
    this.inputs = model.inputs;
    this.type = model.type;
    this.jurisdictionId = model.jurisdictionId;
    this.lineItems = CalculatorLineItem.mapModelsOrNull(model.lineItems);
  }
}
